/**
 * 統計 - 週期
 */
export const SummaryPeriodEnum = Object.freeze({

    /**
     * 天 (1D)
     */
    DAY: 1,

    /**
     * 週 (1W)
     */
    WEEK: 2,

    /**
     * 月 (1M)
     */
    MONTH: 3,

    /**
     * 季 (1Q)
     */
    SEASON: 4,

    /**
     * 半年 (2Q)
     */
    HALF_YEAR: 5,

    /**
     * 1年 (1Y)
     */
    YEAR: 6,

    /**
     * 3年 (3Y)
     */
    THREE_YEAR: 7,

})